export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7937.084e9363.jpg";